export const TestIds = {
  labelWrapper: 'labelWrapper',
} as const;
